<template>
  <v-div class="SearchFacets" background-subdued pl-2 pr-2 pt-4 pb-4>
    <v-div v-if="showSubjects">
      <MatchSet
        title="Subjects"
        :title-color="titleColor"
        :title-bold="titleBold"
        :buckets="subjectBuckets"
        :selected="selectedSubjects"
        @selectionChanged="$emit('subjectChanged', $event)"
      />
    </v-div>
    <v-div v-if="showCategories">
      <MatchSet
        title="Categories"
        :title-color="titleColor"
        :title-bold="titleBold"
        :buckets="categoryBuckets"
        :selected="selectedCategories"
        @selectionChanged="$emit('categoryChanged', $event)"
      />
    </v-div>
    <v-div v-if="showEvents">
      <MatchSet
        title="Events"
        :title-color="titleColor"
        :title-bold="titleBold"
        :buckets="eventBuckets"
        :selected="selectedEvents"
        @selectionChanged="$emit('eventChanged', $event)"
      />
    </v-div>
    <v-div v-if="showContentTypeFacets" pt-3>
      <MatchSet
        title="Content Types"
        :title-color="titleColor"
        :title-bold="titleBold"
        :buckets="contentBuckets"
        :selected="selectedContents"
        @selectionChanged="$emit('contentChanged', $event)"
      />
    </v-div>
    <v-div pt-3>
      <MatchSet
        title="Published Date"
        :title-color="titleColor"
        :title-bold="titleBold"
        :buckets="publishedDateBuckets"
        :selected="selectedPublishedDates"
        @selectionChanged="$emit('publishedDateChanged', $event)"
      />
    </v-div>
    <v-div v-if="showPartners" pt-3>
      <LinkSet
        title="Partners"
        :title-color="titleColor"
        :title-bold="titleBold"
        :buckets="partnerBuckets"
        :selected="selectedPartners"
        @selectionChanged="$emit('partnerChanged', $event)"
      />
    </v-div>
    <!-- Keywords -->
    <v-div pt-3>
      <v-div title :font-weight-bold="titleBold" :foreground="titleColor"
        >Keywords</v-div
      >
      <v-div pl-2 pr-2>
        <LookupSelector
          :selected="selectedKeywords"
          aria-label="keyword"
          :source="graphql"
          @selectionUpdated="onSearchKeyword"
        />
      </v-div>
      <v-div border-bottom-inverted-thick mt-3 ml-1 mr-1 />
    </v-div>
    <!-- Authors see HACK needs to be removed when search accepts an array -->
    <v-div pt-3>
      <v-div title :font-weight-bold="titleBold" :foreground="titleColor"
        >Authors</v-div
      >
      <v-div pl-2 pr-2>
        <OptionsSelector
          :selected="selectedAuthors"
          aria-label="author"
          @selectionUpdated="onSearchAuthor"
        />
      </v-div>
    </v-div>
  </v-div>
</template>

<script>
import { mapState } from "vuex";

import { keywordsSearch } from "~/store/graphql/queries/keywordsSearch.graphql";

import MatchSet from "~/components/matches/components/MatchSet.vue";
import LinkSet from "~/components/matches/components/LinkSet.vue";

import OptionsSelector from "~/components/matches/components/OptionsSelector.vue";
import LookupSelector from "~/components/matches/components/LookupSelector.vue";

export default {
  name: "SearchFacets",
  components: {
    OptionsSelector,
    LookupSelector,
    MatchSet,
    LinkSet,
  },
  props: {
    subjectBuckets: { type: Array, required: true },
    categoryBuckets: { type: Array, required: true },
    eventBuckets: { type: Array, required: true },
    partnerBuckets: { type: Array, required: true },
    contentBuckets: { type: Array, required: true },
    publishedDateBuckets: { type: Array, required: true },
    selectedSubjects: { type: Array, default: () => [] },
    selectedEvents: { type: Array, default: () => [] },
    selectedCategories: { type: Array, default: () => [] },
    selectedPartners: { type: Array, default: () => [] },
    selectedContents: { type: Array, default: () => [] },
    selectedAuthors: { type: Array, default: () => [] },
    selectedKeywords: { type: Array, default: () => [] },
    selectedPublishedDates: { type: Array, default: () => [] },
    showSubjects: { type: Boolean, default: false },
    showEvents: { type: Boolean, default: false },
    showCategories: { type: Boolean, default: false },
    showPartners: { type: Boolean, default: false },
    showPublishedDate: { type: Boolean, default: false },
    showContentTypeFacets: { type: Boolean, default: false },
  },
  data: () => {
    return {
      graphql: keywordsSearch,
    };
  },
  computed: {
    ...mapState({
      layout: (state) => state.theme.layout,
    }),
    titleColor() {
      return this.layout.searchFacetsTitleColor;
    },
    titleBold() {
      return this.layout.searchFacetsTitleBold;
    },
  },
  methods: {
    onSearchAuthor(value) {
      this.$emit("authorsChanged", value);
    },
    onSearchKeyword(value) {
      this.$emit("keywordsChanged", value);
    },
  },
};
</script>
